import { render, staticRenderFns } from "./AviaController.vue?vue&type=template&id=bf45e48e&scoped=true"
import script from "./AviaController.vue?vue&type=script&lang=js"
export * from "./AviaController.vue?vue&type=script&lang=js"
import style0 from "./AviaController.vue?vue&type=style&index=0&id=bf45e48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf45e48e",
  null
  
)

export default component.exports